import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { IconDefinition, faChartBar, faChartLine, faClipboard, faLock, faPaintBrush, faTableColumns, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { TranslateService } from "@tolgee/ngx";
import { Collapse, Drawer, Dropdown } from 'flowbite';
import { environment } from "src/environments/environment";
import { AuthService } from "src/services/auth.service";


declare interface RouteInfo {
  path: string;
  title: string;
  icon: IconDefinition;
  class: string;
}

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})

export class SidebarComponent implements OnInit {
  @ViewChild('adminBtn') adminBtn!: ElementRef;
  @ViewChild('admin') admin!: ElementRef;
  @ViewChild('sidebar') sidebar!: ElementRef;
  @Output() event = new EventEmitter<void>();
  langDropdown!: Dropdown;
  isAdmin: boolean = false;
  faLock = faLock;
  canny = environment.canny;
  @Input() drawer: Drawer | null = null;

  constructor(public translateService: TranslateService, private auth: AuthService) { }

  userMenuItems: RouteInfo[] = [
    { path: "/dashboard", title: "Dashboard", icon: faTableColumns, class: "" },
    { path: "/progress", title: "Progress", icon: faChartLine, class: "" },
    { path: "/results", title: "My Results", icon: faClipboard, class: ""},
    { path: "/evaluations", title: "Evaluations", icon: faChartBar, class: ""},
    { path: "/groups", title: "Groups", icon: faUsers, class: "" },
    { path: "/relations", title: "Relations", icon: faUser, class: ""},
  ]

  adminMenuItems: RouteInfo[] = [
    { path: "/indicators", title: "Indicators", icon: faPaintBrush, class: "" },
    //{ path: "/skills", title: "Skills", icon: faPaintBrush, class: "" },
  ]

  ngOnInit() {
    this.auth.isAdmin().then(isAdmin => {
      this.isAdmin = isAdmin;
    }).catch(() => {
      this.isAdmin = false;
    }).then(() => {
      if(this.isAdmin) new Collapse(this.admin.nativeElement, this.adminBtn.nativeElement);
    });
  }

  toggleCollapse(id: HTMLUListElement) {
    if (id.classList.contains("hidden")) {
      id.classList.remove("hidden");
    } else {
      id.classList.add("hidden");
    }
  }

  closeNav() {
    if (this.drawer) {
      this.drawer.hide();
    }
  }

}
